import firebase from 'firebase/app';
import 'firebase/firebase-analytics';
import { firebaseConfig } from './settings.js';

firebase.initializeApp(firebaseConfig);

const MyAnalytics = firebase.analytics();

export { MyAnalytics }